import React, { useEffect, useState } from "react";
import { FiArrowLeft, FiCalendar, FiClock, FiCheckCircle, FiXCircle, FiAlertCircle } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { getUserCorrections } from "../../../Redux/Slice/AttendanceCorrection";
import moment from "moment";
import Loader from "../../../Components/Loader/Loader";
import { TablePagination } from "@mui/material";
const MyCorrection = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Get User ID from Cookies
    const loginData = Cookies.get("loginData");
    const parsedData = loginData ? JSON.parse(loginData) : null;
    const userId = parsedData?.data?._id;

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const { corrections, loading } = useSelector((state) => state.AttendanceCorrection);

    useEffect(() => {
        if (userId) {
            dispatch(getUserCorrections(userId));
        }
    }, [dispatch, userId]);

    const getStatusStyle = (status) => {
        switch (status.toLowerCase()) {
            case 'pending': return 'bg-orange-50 text-orange-500 border-orange-100';
            case 'approved': return 'bg-emerald-50 text-emerald-600 border-emerald-100';
            case 'rejected': return 'bg-red-50 text-red-500 border-red-100';
            default: return 'bg-gray-50 text-gray-500 border-gray-100';
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className="px-3 py-6 min-h-0 font-sans bg-[#f8fafc]/50">
                <div className="w-full space-y-6">

                    {/* Header Section */}
                    <div className="bg-white p-4 sm:p-5 rounded-2xl shadow-[0_2px_15px_rgba(0,0,0,0.03)] border border-gray-100 flex items-center gap-4">
                        <button
                            onClick={() => navigate("/MyAttendance")}
                            className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-50 text-gray-400 hover:bg-gray-100 hover:text-gray-900 transition-all active:scale-95 border border-gray-200"
                        >
                            <FiArrowLeft size={16} />
                        </button>
                        <div>
                            <h1 className="text-lg font-bold text-gray-900 tracking-tight">My Correction Requests</h1>
                            <p className="text-gray-600 text-xs font-semibold mt-0.5 tracking-wide">Track the status of your attendance discrepancies</p>
                        </div>
                    </div>

                    {/* Main Content - History Table */}
                    <div className="bg-white rounded-2xl shadow-[0_2px_15px_rgba(0,0,0,0.03)] border border-gray-100 overflow-hidden">
                        <div className="p-4 border-b border-gray-50">
                            <h2 className="text-base font-bold text-gray-800 tracking-tight">Request History</h2>
                        </div>

                        <div className="bg-white shadow-lg rounded-xl overflow-hidden border border-gray-100 relative z-0 mt-3 mx-4 mb-4">
                            <div className="w-full overflow-x-auto" style={{ width: "100%" }}>
                                <div className="min-w-[1000px] overflow-hidden relative z-0">
                                    <div className="max-h-[600px] overflow-y-auto relative scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
                                        <table className="min-w-full table-auto border-collapse divide-y divide-gray-200 text-sm">
                                            <thead className="bg-[#133A69] text-white sticky top-0 z-50">
                                                <tr>
                                                    <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider whitespace-nowrap" style={{ minWidth: "150px" }}>Target Date</th>
                                                    <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider whitespace-nowrap" style={{ minWidth: "250px" }}>Your Reason</th>
                                                    <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider whitespace-nowrap" style={{ minWidth: "150px" }}>Applied Date</th>
                                                    <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider whitespace-nowrap" style={{ minWidth: "150px" }}>Status</th>
                                                    <th className="px-4 py-3 text-left text-xs font-bold uppercase tracking-wider whitespace-nowrap" style={{ minWidth: "200px" }}>Admin Note</th>
                                                </tr>
                                            </thead>
                                <tbody className="divide-y divide-gray-100">
                                    {corrections && corrections.length > 0 ? (
                                        corrections.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((req) => (
                                            <tr key={req._id} className="group hover:bg-gray-50/50 transition-colors">
                                                <td className="px-4 py-3 border-b border-gray-100 whitespace-nowrap">
                                                    <div className="flex items-center gap-2">
                                                        <div className="w-5 h-5 rounded-lg text-blue-500 flex items-center justify-center shrink-0">
                                                            <FiCalendar size={14} />
                                                        </div>
                                                        <span className="text-xs font-semibold text-gray-900">{moment(req.correctionDate).format("D MMM YYYY")}</span>
                                                    </div>
                                                </td>
                                                <td className="px-4 py-3 border-b border-gray-100">
                                                    <p className="text-xs text-gray-700 font-medium italic leading-relaxed max-w-lg min-w-[250px]">
                                                        "{req.reason}"
                                                    </p>
                                                </td>
                                                <td className="px-4 py-3 border-b border-gray-100 text-xs font-semibold text-gray-700 tabular-nums whitespace-nowrap">
                                                    {moment(req.appliedDate).format("DD/MM/YYYY")}
                                                </td>
                                                <td className="px-4 py-3 border-b border-gray-100 whitespace-nowrap">
                                                    <span className={`px-3 py-1 rounded-full text-[10px] font-semibold border uppercase tracking-widest inline-block ${getStatusStyle(req.status)}`}>
                                                        {req.status}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 border-b border-gray-100">
                                                    {req.adminNote ? (
                                                        <span className="text-xs font-semibold text-gray-700 italic">
                                                            {req.adminNote}
                                                        </span>
                                                    ) : (
                                                        <span className="text-[10px] font-semibold text-gray-500 italic bg-gray-55 px-2 py-0.5 rounded border border-gray-150 tracking-wider">
                                                            AWAITING REVIEW
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="px-4 py-16 text-center text-gray-500 font-medium italic">
                                                No correction requests found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            </div>
                            </div>
                            <TablePagination
                                component="div"
                                count={corrections?.length || 0}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                className="bg-white border-t border-gray-100 placeholder:text-gray-500 rounded-[0px_0px_24px_24px]"
                            />
                            </div>
                        </div>
                    </div>

                    {/* Footer Info Banner */}
                    <div className="bg-indigo-50 p-4 sm:p-5 rounded-2xl sm:rounded-3xl border border-indigo-100 flex gap-4 sm:gap-5 items-start">
                        <div className="w-5 h-5 sm:w-6 sm:h-6 p-1 bg-indigo-500 text-white rounded-lg sm:rounded-xl shadow-lg shadow-indigo-100 flex items-center justify-center shrink-0">
                            <FiClock size={10} className="sm:size-12" />
                        </div>
                        <div>
                            <h3 className="text-xs sm:text-sm font-semibold text-indigo-900 tracking-tight">Processing Time</h3>
                            <p className="text-indigo-700 text-[11px] sm:text-[12px] font-medium leading-relaxed mt-1">
                                Most correction requests are reviewed by admin within 24-48 hours. Once approved, your attendance logs will be updated automatically.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default MyCorrection;